"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const react_router_dom_1 = require("react-router-dom");
const Link_1 = __importDefault(require("@material-ui/core/Link"));
const Launch_1 = __importDefault(require("@material-ui/icons/Launch"));
const clsx_1 = __importDefault(require("clsx"));
const externalPattern = /^((https?):\/\/)/;
const useStyles = styles_1.makeStyles({
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    launchIcon: {
        verticalAlign: 'middle',
        width: '16px',
        marginLeft: '3px',
    },
    noneDecorationHover: {
        '&:hover': {
            textDecoration: 'none',
        },
    },
});
/** A link is an anchor tag that defines a hyperlink, which a user can click to find out more information about a concept, task, or field. */
const Link = (_a) => {
    var { target = '_self', children, href, underlineHover = true, forceExternal = false, onClick } = _a, props = __rest(_a, ["target", "children", "href", "underlineHover", "forceExternal", "onClick"]);
    const classes = useStyles();
    const isExternal = react_1.useMemo(() => forceExternal || externalPattern.test(href), [forceExternal, href]);
    return (react_1.default.createElement(Link_1.default, { component: isExternal ? 'a' : react_router_dom_1.Link, className: clsx_1.default(classes.link, { [classes.noneDecorationHover]: !underlineHover }), target: target, href: href, to: href, variant: "body1", "data-testid": props['data-testid'], rel: isExternal ? 'noreferrer' : undefined, onClick: onClick },
        children,
        isExternal && react_1.default.createElement(Launch_1.default, { className: classes.launchIcon, titleAccess: "launch" })));
};
exports.default = Link;
